
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kredit-kamera",
      function () {
        return require("private-next-pages/kredit-kamera.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kredit-kamera"])
      });
    }
  